// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"e3bb71fc","80":"b24d6d07","358":"7ee6741f","496":"937e1cf5","748":"df2c6abd","763":"99ae05d0","835":"da4e8f17","926":"0c846b1a"}[chunkId] + ".chunk.css";
};